import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { isEmpty } from "lodash"

import InputField from "components/input"
import SubmitNotification from "components/common/submit-notification"
import Button from "components/common/Button"

import {
  submitForumComment,
  updateForumComment,
  closeForumModal,
  addCommentToAnswer,
  editCommentOnAnswer,
} from "store/school/actions"

export class CommentForm extends Component {
  constructor() {
    super()

    this.state = {
      commentForm: {
        comment_text: "",
      },
      fieldErrors: {},
    }
  }

  componentDidMount() {
    const {
      school: {
        forumModal: { isEdit = false },
        commentData = {},
      },
    } = this.props

    if (isEdit) {
      this.setState({
        commentForm: {
          comment_text: commentData.comment_text,
        },
        commentId: commentData.id,
      })
    }
  }

  componentDidUpdate(prevProps) {
    const {
      school: { errors },
    } = this.props

    const {
      school: { errors: prevErrors },
    } = prevProps

    if (errors !== prevErrors) {
      this.setState({ fieldErrors: errors })
    }
  }

  handleChange = (e) => {
    const { commentForm } = this.state
    const { name, value } = e.currentTarget
    this.setState(
      {
        commentForm: {
          ...commentForm,
          [name]: value,
        },
      },
      () => {
        this.validateField(name)
      }
    )
  }

  validateField = (fieldName) => {
    const { fieldErrors, commentForm } = this.state

    if (isEmpty(commentForm[fieldName])) {
      fieldErrors[fieldName] = "This field is required"
    } else {
      delete fieldErrors[fieldName]
    }
    this.setState({ fieldErrors })
  }

  onSubmit = () => {
    const {
      school: {
        forumModal: { isEdit = false },
        questionData,
        commentData,
      },
      submitForumComment,
      updateForumComment,
      addCommentToAnswer,
      editCommentOnAnswer,
    } = this.props

    const { commentForm = {}, commentId = null, fieldErrors = {} } = this.state
    if (isEmpty(fieldErrors)) {
      let payload = commentForm
      if (commentData?.commentToAnswer) {
        if (isEdit && commentId) {
          payload["id"] = commentData.id
          editCommentOnAnswer(payload)
        } else {
          payload["answer"] = commentData.id
          addCommentToAnswer(payload)
        }
      } else {
        if (isEdit && commentId) {
          updateForumComment(commentId, payload)
        } else {
          payload["question"] = questionData.id
          submitForumComment(payload)
        }
      }
    }
  }

  render() {
    const {
      school: {
        questionData,
        commentData,
        forumModal: { errors, isEdit },
      },
      closeForumModal,
    } = this.props

    const { commentForm = {}, fieldErrors = {} } = this.state

    return (
      <div className="is-fullwidth">
        <div>
          <SubmitNotification
            type={errors && errors.non_field_errors && "FAILED"}
            message={errors && errors.non_field_errors}
          />
          {!isEdit && (
            <div className="text-container">
              <p style={{ lineHeight: 1.5, wordWrap: "break-word" }}>
                {commentData?.commentToAnswer
                  ? commentData["answer_text"]
                  : questionData["description"]}
              </p>
            </div>
          )}
          <div className="control">
            <InputField
              label="Comment"
              name="comment_text"
              type="textarea"
              required={true}
              value={commentForm["comment_text"]}
              error={fieldErrors["comment_text"]}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className="has-text-right">
          <Button
            label="Cancel"
            ghost={true}
            customClassName="mr-m"
            onClick={closeForumModal}
          />
          <Button label="Post" onClick={this.onSubmit} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      submitForumComment,
      updateForumComment,
      closeForumModal,
      addCommentToAnswer,
      editCommentOnAnswer,
    },
    dispatch
  )

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  CommentForm
)
